import { jsx as _jsx } from "react/jsx-runtime";
import { Tabs, TabsList, TabsTrigger } from "./Tabs";
export const ButtonBar = (props) => {
    const { items, activeId, onChange, className, buttonClassName } = props;
    return (_jsx(Tabs, { value: activeId, onValueChange: onChange, className: className, children: _jsx(TabsList, { children: items.map(item => (_jsx(TabsTrigger, { className: buttonClassName, value: item.id, disabled: item.disabled, children: item.title }, item.id))) }) }));
};
